export const getColorByCode = (code, isDarkMode) => {
  const lowerCaseCode = code.toLowerCase();
  if (isDarkMode) {
    return `${lowerCaseCode}.500`;
  }
  return `${lowerCaseCode}.100`;
};
